import store from 'store';
import Abstract from './class.Abstract';
import { qs } from '../dom-helpers';

class Checkout extends Abstract {
  constructor() {
    super();

    if (this.isThankYou) {
      this._clearStores();
      return;
    }

    if (!this.isCheckout) return;

    this.orderCommentsTextarea = qs('.checkout-comments-textarea');
    this.deliveryDateInput = qs('.checkout-delivery-date-input');
    this.deliveryDateInputUTC = qs('.checkout-delivery-date-input-utc');

    this._run();
  }

  _run() {
    this._setOrderNotes();
    this._setDeliveryDate();
  }

  _clearStores() {
    store.remove(this.ORDER_COMMENTS_KEY);
    store.remove(this.DELIVERY_DATE_KEY);
    store.remove(this.DELIVERY_DATE_KEY+'U');
  }

  _setOrderNotes() {
    if (!this.orderCommentsTextarea) return;

    if (store.get(this.ORDER_COMMENTS_KEY)) {
      this.orderCommentsTextarea.value = store.get(this.ORDER_COMMENTS_KEY);
    }
  }

  _setDeliveryDate() {
    if (!this.deliveryDateInput) return;

    if (store.get(this.DELIVERY_DATE_KEY)) {
      this.deliveryDateInput.value = store.get(this.DELIVERY_DATE_KEY);
    }

    if (!this.deliveryDateInputUTC) return;

    var utc = store.get(this.DELIVERY_DATE_KEY+'U');

    if (utc) {
      this.deliveryDateInputUTC.value = utc;
    }
  }
}

export default Checkout;
